import { HTTPMethod } from 'helpers/method';
import i18n from 'i18next';
import { ENDPOINT } from 'services/configs/endpoint.constant';

import {
  AddQuestionParams,
  AddQuestionResponse,
  DeleteConversationParams,
  EditConversationNamePayload,
  EditConversationNameResponse,
  EditQuestionParams,
  EditQuestionResponse,
  GetConversationsParams,
  GetConversationsResponse,
  GetDetailConversationParams,
  GetDetailConversationResponse,
  GetLatestMessageConversationParams,
  GetLatestMessageConversationResponse,
  ListSupportedModelResponse,
} from './conversation.type';
import { request } from '../configs/axiosConfig';

export const ConversationService = {
  getDetailConversation: async (params: GetDetailConversationParams) => {
    return request<GetDetailConversationResponse>({
      method: HTTPMethod.GET,
      url: ENDPOINT.GET_DETAIL_CONVERSATION,
      params,
    });
  },
  getLatestMessageConversation: async (params: GetLatestMessageConversationParams) => {
    return request<GetLatestMessageConversationResponse>({
      method: HTTPMethod.GET,
      url: ENDPOINT.GET_LATEST_MESSAGE_CONVERSATION,
      params,
    });
  },
  getConversations: async (params: GetConversationsParams) => {
    return request<GetConversationsResponse>({
      method: HTTPMethod.GET,
      url: ENDPOINT.GET_CONVERSATIONS,
      params,
    });
  },
  editConversationName: async (data: EditConversationNamePayload) => {
    return request<EditConversationNameResponse>({
      method: HTTPMethod.PUT,
      url: ENDPOINT.EDIT_CONVERSATION_NAME,
      data,
    });
  },
  deleteConversation: async (params: DeleteConversationParams) => {
    return request({ method: HTTPMethod.DELETE, url: ENDPOINT.DELETE_CONVERSATIONS, params });
  },
  addQuestion: async (body: AddQuestionParams) => {
    return request<AddQuestionResponse>({
      method: HTTPMethod.POST,
      url: ENDPOINT.ADD_QUESTION,
      data: body,
    });
  },
  editQuestion: async (body: EditQuestionParams) => {
    return request<EditQuestionResponse>({
      method: HTTPMethod.PUT,
      url: ENDPOINT.EDIT_QUESTION,
      data: body,
    });
  },
  listSupportedModel: async () => {
    return request<ListSupportedModelResponse>({
      method: HTTPMethod.GET,
      url: ENDPOINT.LIST_SUPPORTED_MODEL,
      params: {
        locale: i18n.language,
      },
    });
  },
};
